import { toggleItems } from "app/components/widget/widget-utilities/time-granularity";
import { EGraphGranularities } from "app/common/keyword-research/serp-players/consts";
import type { GraphType } from "app/common/keyword-research/clicks-over-time-graph/graphTypes";
import type { ValueOf } from "pro-features/types";
import { BasicDurations } from "app/services/DurationService";
import type dayjs from "dayjs";

export const DEFAULT_GRAPH_TYPE = 1;
export const THIRTEEN_MONTHS_INDEX = 3;
export const TWENTY_EIGHT_DAYS_OR_1_MONTH_INDEX = 0;

export const DASHBOARD_TYPE = "KeywordAnalysisGraphDashboard";
const DASHBOARD_METRIC = "ClicksOverTime";
export const TIME_GRANULARITY = "timeGranularity";

// const EXCEL_ENDPOINT = "widgetApi/KeywordAnalysisV2/KeywordAnalysisOrganic/SiteTraffic/excel";
export const graphTypeTooltips: Record<GraphType, { title: string; subtitle: string }> = {
    overview: {
        title: "keywordanalysis.organic2.clicks.over.time.chart.type.traffic.share.title",
        subtitle: "keywordanalysis.organic2.clicks.over.time.chart.type.traffic.share.subtitle",
    },
    "stacked-chart": {
        title: "keywordanalysis.organic2.clicks.over.time.chart.type.stacked.chart.title",
        subtitle: "keywordanalysis.organic2.clicks.over.time.chart.type.stacked.chart.subtitle",
    },
    "chart-stacked-share": {
        title: "keywordanalysis.organic2.clicks.over.time.chart.type.stacked.share.title",
        subtitle: "keywordanalysis.organic2.clicks.over.time.chart.type.stacked.share.subtitle",
    },
};

export const GRAPH_TYPE_TO_TRACKING_NAME: Record<GraphType, string> = {
    overview: "LINE_GRAPH",
    "stacked-chart": "TRAFFIC_TREND",
    "chart-stacked-share": "MARKET_SHARE",
};
export const GRAPH_GRANULARITY_TO_TRACKING_NAME: Record<EGraphGranularities, string> = {
    [EGraphGranularities.DAILY]: "DAILY",
    [EGraphGranularities.WEEKLY]: "WEEKLY",
    [EGraphGranularities.MONTHLY]: "MONTHLY",
};

export const GRAPH_GRANULARITIES = [toggleItems.Daily.title, toggleItems.Weekly.title, toggleItems.Monthly.title];

export const GraphDurationToAmountAndUnit: Partial<Record<ValueOf<typeof BasicDurations>, [number, dayjs.OpUnitType]>> =
    {
        [BasicDurations.LAST_TWENTY_EIGHT_DAYS]: [28, "days"],
        [BasicDurations.LAST_MONTH]: [1, "month"],
        [BasicDurations.LAST_THREE_MONTHS]: [3, "months"],
        [BasicDurations.LAST_SIX_MONTHS]: [6, "months"],
        [BasicDurations.LAST_THIRTEEN_MONTHS]: [13, "months"],
    };
